import { createSlice } from '@reduxjs/toolkit';
import { fetchCarCharterOrder } from './actions';

const initialState = {
  data: {},
  page: 1,
  status: 'idle', //'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

export const carCharterOrder = createSlice({
  name: 'carCharterOrder',
  initialState,
  reducers: {
    // reducers goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCarCharterOrder.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchCarCharterOrder.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(fetchCarCharterOrder.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      });
  },
});

export default carCharterOrder.reducer;
